import { LimitType } from '../types/limits';

export const getLimitDetails = (limitType: LimitType) => ({
	text: `project.notifications.limit.${limitType}.text`,
	title: `project.notifications.limit.${limitType}.title`
});
